<template>
  <div
    class="w-full h-full flex justify-center items-center text-caramel-primary-600"
  >
    <Loading />
  </div>
</template>

<script>
import Loading from '@/assets/Icons/Caramel/Loading'

export default {
  components: { Loading },
}
</script>

<style>
.animate-spin {
  transform-origin: center;
  animation: rotateAnimation 1s linear infinite;
}

@keyframes rotateAnimation {
  to {
    transform: rotate(360deg);
  }
}
</style>
